import { StringToPrimitive } from './'

/**
  * Checks an object to see if it has any props
  * @param {Object} obj - the object to query
  * @returns {Boolean}
  */
const _isEmptyObject = obj => {
  let hasProps = true
  for (const prop in obj) {
    hasProps = false
    break
  }
  return hasProps
}


/**
  * Overwrites props of a given baseObject with matching props from a given merge Object,
  * ignoring any props not referenced in the base Object
  * @param {Object} baseObj - The orginal object into which new props should be merged
  * @param {Object} mergeObj - The new object which should overwrite the defaults in baseObj
  * @returns {Object} - A merge of the 2 objects
  */
const merge = (baseObj, mergeObj) => {
  const extendedObj = {};

  for (const prop in baseObj) {
    if (mergeObj.hasOwnProperty(prop)) {
      if (typeof baseObj[prop] === 'object') {

        extendedObj[prop] = _isEmptyObject(baseObj[prop])
          ? mergeObj[prop]
          : merge(extendedObj[prop], mergeObj[prop]);

      } else {

        extendedObj[prop] = StringToPrimitive.convert(mergeObj[prop]);

      }
    } else {

      extendedObj[prop] = baseObj[prop];

    }
  }

  return extendedObj;
}

const ConfigObj = { merge }
export default ConfigObj



// WEBPACK FOOTER //
// ./js/utils/ConfigObj.js